import {USER_DETAILS_FETCHED} from '../../actions/types';

export default function(state = {}, action){
    switch (action.type){
        case USER_DETAILS_FETCHED:
            return action.payload;
        default:
            break;
    }
    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/User/index.js